import React from 'react';
import { RouterAccount, RouterAccountCallback, RouterSocialLogin } from './route.paths';

type RoutesNames = 'account' | 'account-callback' | 'social-login';

interface Props {
  appUrl: RoutesNames;
}

// the App must be a default export due to `loadable`
//   so we have to do some conditional logic :(
export const AccountApp: React.FC<Props> = ({ appUrl }) => {
  switch (appUrl) {
    case 'account':
      return <RouterAccount appUrl={appUrl} />;
    case 'account-callback':
      return <RouterAccountCallback appUrl={appUrl} />;
    case 'social-login':
      return <RouterSocialLogin appUrl={appUrl} />;
    default:
      return null;
  }
};

export default AccountApp;
